import { render, staticRenderFns } from "./KnowledgeBaseCategoryQuestion.vue?vue&type=template&id=41070e2b"
import script from "./KnowledgeBaseCategoryQuestion.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseCategoryQuestion.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseCategoryQuestion.vue?vue&type=style&index=0&id=41070e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports